module.exports = __webpack_public_path__ + "img/T2D_xh_0.bd355fba.png";